import { render, staticRenderFns } from "./talentDirectory.vue?vue&type=template&id=4dae580c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dae580c')) {
      api.createRecord('4dae580c', component.options)
    } else {
      api.reload('4dae580c', component.options)
    }
    module.hot.accept("./talentDirectory.vue?vue&type=template&id=4dae580c", function () {
      api.rerender('4dae580c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/talentDirectory.vue"
export default component.exports